import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { TokenService } from '../../services/token/token.service';

@Injectable({
  providedIn: 'root',
})
export class IsFullyAuthenticatedGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private tokenService: TokenService
  ) {}

  canActivate(): Observable<boolean> {
    return this.authenticationService.verifyUser().pipe(
      map(() => {
        // console.log(this.authenticationService.isAuthenticated(), this.tokenService.isEmailVerified());
        if (!this.authenticationService.isAuthenticated()) {
          this.router.navigateByUrl('login');
        } else if (
          this.authenticationService.isAuthenticated() &&
          !this.tokenService.isEmailVerified()
        ) {
          this.router.navigateByUrl('verify-email');
          return false;
        }
        return true;
      }),
      catchError(() => {
        this.router.navigateByUrl('login');
        return of(false);
      })
    );
  }
}
